import "./index.scss"
import "./XueLiAuthArea.scss"
import "./Zszx.scss"
import "./XueLiBlock.scss"
import "./Jxd.scss"
import "./Jxd.js"
import "./XueLiCourseList.scss"
import "./Process.scss"
import "./Why.scss"
import "./XueLiCourseList.js"


/** WEBPACK FOOTER **
 ** ./src/XueLiJiaoYu/index.js
 **/